import $ from 'jquery';
import {decompressXML} from "./diagramEditor";
import diagramFile from "../../resources/parent_test.drawio.svg"
import {NodeTypeMapping} from "./nodeMappings";
import generatedJson from "../../resources/diet-data-drawio.json"
import parse from 'html-react-parser';
import {useEffect, useRef, useState} from "react";
import {getJsonData} from "./diagramParsing";
/*import svg from "../../resources/parent_test.drawio.svg";*/

export function DiagramSvgForm() {
    const [svg, setSvg] = useState();
    const templateXml = useRef();
    const selectedDataNode = useRef();
    const svgDocument = useRef();
    const once = useRef(false);


    useEffect(()=>{
        let xhttp = new XMLHttpRequest();
        xhttp.open("GET", diagramFile, false);
        xhttp.send();
        svgDocument.current = xhttp.responseXML;
        templateXml.current = decompressXML($(xhttp.responseXML).find("svg").attr("content"));
        handleAfterInjection(svgDocument.current);
        setSvg(svgDocument.current);
    },[])

    useEffect(()=>{
        if(svg && !once.current) {
            once.current = true;
            let rowArray = getRowArray(generatedJson);
            rowArray.forEach((row) => {
                Object.values(row).forEach((value) => {
                    let id = value.nodeId;
                    let element = document.getElementById(`cell-${id}`);
                    let nodeType = element.getAttribute("data-nodetype");
                    if(nodeType === NodeTypeMapping.DATA) {
                        element?.addEventListener("mouseenter", function () {
                            element.setAttribute("stroke-width", "2");
                        });
                        element?.addEventListener("mouseleave", function () {
                            element.setAttribute("stroke-width", "1");
                        });
                        element?.addEventListener("click", function (ev) {
                            ev.stopPropagation();
                            selectedDataNode.current = $(svgDocument.current).find(`[id=cell-${id}]`);
                            let left = parseFloat($(element).find("rect").attr("x"));
                            let top = parseFloat($(element).find("rect").attr("y"));
                            let $input = $("#dataInput");
                            $input.val(element.getAttribute("data-value"));
                            $input.css("left", left);
                            $input.css("top", top);
                            $input.css("width", element.getBoundingClientRect().width);
                            $input.css("height", element.getBoundingClientRect().height);
                            $input.css("visibility", "visible");
                            $input.trigger("focus");
                        });
                    }
                })
            });
        }

    },[svg]);

    function handleFocus(e){
        e.target.select();
    }

    function handleBlur(e){
        $(e.target).css("visibility", "hidden");
        if (selectedDataNode.current && e.target.value) {
            setDataNodeValue(e.target.value, selectedDataNode.current);
            let copy = svgDocument.current.cloneNode(true);
            setSvg(copy);
        }
    }

    function handleKeyUp(event){
        if (event.key === 'Enter') {
            event.target.blur();
        }
    }

    function handleAfterInjection(svg){
        //assignHeaderIds(svg, templateXml.current);
        injectData(generatedJson);
        hideDashedLines(svg);
        let bgImage = ' background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJod' +
            'HRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblV' +
            'uaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgNDAgMTAgTSAxMCAwIEwgMTAgNDAgTSAwIDIwIEwgNDAgMjAgTSAyMCAw' +
            'IEwgMjAgNDAgTSAwIDMwIEwgNDAgMzAgTSAzMCAwIEwgMzAgNDAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2QwZDBkMCIgb3BhY2l0eT0iMC4yIi' +
            'BzdHJva2Utd2lkdGg9IjEiLz48cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZDBkMGQwIiBzdHJva2U' +
            'td2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=");';

        $(svg).find('svg').attr("style", bgImage);
    }

    function getRowArray(generatedJson){
        return [
            ...function _flatten(o) {
                return [].concat(...Object.keys(o)
                    .map(k =>
                        typeof o[k] === 'object' && !Array.isArray(o[k]) ?
                            _flatten(o[k]) :
                            (o[k])
                    )
                );
            }(generatedJson)
        ]
    }

    function injectData(json){
        let rowArray = getRowArray(json);
        rowArray.forEach((row)=>{
            Object.values(row).forEach((value)=>{
                let id = value.nodeId;
                let node = $(svgDocument.current).find(`[id=cell-${id}]`);
                if(value.value) {
                    setDataNodeValue(value.value, node);
                }
            })
        })
    }

    /*function assignHeaderIds(svg, xml) {
        let groups = $(xml).find("object>[style*=container]");
        for (let i = 0; i < groups.length; i++) {
            if ($(groups[i]).parent().attr("data")) {
                $(groups[i]).parent().attr("tooltip", "");
                let children = $(xml).find("object>[parent=" + $(groups[i]).parent().attr("id") + "]");
                for (let j = 0; j < children.length; j++) {
                    let elem = $(children[j]).parent();
                    $(elem).attr("data", /!*$(elem).attr("data") +*!/ $(groups[i]).parent().attr("data"));
                }
            }
        }
    }*/

    function hideDashedLines(svg) {
        let dashedLines = $(svg).find("[stroke-dasharray]");
        for (let i = 0; i < dashedLines.length; i++) {
            $(dashedLines[i]).attr("stroke", "none");
        }
    }

    function setDataNodeValue(value, node) {
        let units = $(node).find("text").html().split(" ")[1];
        $(node).attr("data-value", value);
        $(node).find("text").html(value + " " + units);
        let xmlElementId = $(node).attr("id").replace("cell-", "");
        let xmlElement = $(templateXml.current).find("[id=" + xmlElementId + "]");
        //extractedData[$(xmlElement).attr("data")] = value;
        $(xmlElement).attr("value", value);
    }


    function inputFilter(value){
        return /^(-?\d+(?:[.,]\d*?)?)?$/.test(value);
    }

    const errorMsg = "Solo se permiten valores numéricos decimales";

    function handleInput(e, inputFilter, errMsg) {
        if (inputFilter(e.target.value)) {
            // Accepted value
            if (["keydown", "mousedown", "focusout"].indexOf(e.type) >= 0) {
                e.target.classList.remove("input-error");
                e.target.setCustomValidity("");
            }
            e.target.oldValue = e.target.value;
            e.target.oldSelectionStart = e.target.selectionStart;
            e.target.oldSelectionEnd = e.target.selectionEnd;
        } else if (e.target.hasOwnProperty("oldValue")) {
            // Rejected value - restore the previous one
            e.target.classList.add("input-error");
            e.target.setCustomValidity(errMsg);
            e.target.reportValidity();
            e.target.value = e.target.oldValue;
            e.target.setSelectionRange(e.target.oldSelectionStart, e.target.oldSelectionEnd);
        } else {
            // Rejected value - nothing to restore
            e.target.value = "";
        }
    }

    const slider = $('#diagram');
    let mouseDown = false;
    let startX, scrollLeft;
    let startY, scrollTop;

    let startDragging = function (e) {
        if (e.button === 1 || e.button === 2) {
            const slider = $('#diagram');
            e.preventDefault();
            e.stopPropagation();
            mouseDown = true;
            startX = e.pageX - slider.offset().left;
            scrollLeft = slider.scrollLeft();
            startY = e.pageY - slider.offset().top;
            scrollTop = slider.scrollTop();
            slider.css("cursor", "move");
        }
    };
    let stopDragging = function () {
        mouseDown = false;
        slider.css("cursor", "");
    };

    function scroll(e){
        const slider = $('#diagram');
        e.preventDefault();
        if (!mouseDown) {
            return;
        }
        const x = e.pageX - slider.offset().left;
        const scrollX = x - startX;
        const y = e.pageY - slider.offset().top;
        const scrollY = y - startY;
        slider.scrollLeft(scrollLeft - scrollX);
        slider.scrollTop(scrollTop - scrollY);
    }

    return <>
        <div style={{display: "flex", justifyContent: "flex-end"}} className="p-10">
            <button className="btn btn-rounded btn-purple" onClick={()=>{
                console.log(getJsonData(templateXml.current));}}>
                <i className="far fa-save"></i> Save
            </button>
            <button className="btn btn-rounded btn-purple m-l-5">
                <i className="far fa-times-circle"></i> Exit
            </button>
        </div>
        <div id="diagram" style={{height: "1000px", position: "relative", overflow: "auto", backgroundColor: "white"}}
             onContextMenu={()=>{return false}} onMouseDown={startDragging} onMouseUp={stopDragging} onMouseLeave={stopDragging} onMouseMove={scroll}>
            <input id="dataInput" type="text" onBlur={handleBlur} onFocus={handleFocus} onKeyUp={handleKeyUp} onInput={e=>handleInput(e, inputFilter, errorMsg)}
                   style={{position: "absolute", zIndex: "10", boxSizing: "border-box", textAlign: "center", visibility: "hidden", color: "black"}}/>
            {svg && parse(svg?.documentElement?.outerHTML)}
        </div>
    </>
}